import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { useStatusFilter } from "./useStatusFilter";
import { useAreaFilter } from "./useAreaFilter";
import { useAlertsFilter } from "./useAlertsFilter";
import { useSortByFilter } from "./useSortByFilter";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useEdsFilter } from "./useEdsDatesFilter";
import { useArticleHfbFilter } from "./useArticleHfbFilter";
import { useEdsDateOptions } from "../filters/useEdsDatesSelectArticleFilter";

export function useMediaOverviewFilters(areas: string[], edsDates: string[]) {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.MEDIA_OVERVIEW_FILTERS
  );

  const edsDateOptions = useEdsDateOptions(edsDates);

  const now = Date.now();
  const isPast = (v: string) => new Date(v).getTime() < now;
  const isUpcoming = (v: string) => !isPast(v);

  const pastEdsOptions = edsDateOptions.filter((o) => isPast(o.value));
  const upcomingEdsOptions = edsDateOptions.filter((o) => isUpcoming(o.value));

  const useMediaOverviewFilters = (values: FilterValue[]) => [
    useStatusFilter(),
    useAreaFilter(areas),
    useArticleHfbFilter(),
    useAlertsFilter(),
    useEdsFilter("eds", values, upcomingEdsOptions),
    useEdsFilter("peds", values, pastEdsOptions),
    useSortByFilter(values),
  ];

  return {
    useFiltersFactory: useMediaOverviewFilters,
    filterValues,
    setFilterValues,
  };
}
